import { useMutation } from '@apollo/client';
import GoExternal from '@clearkit/icons/glyphs/GoExternal';
import { CKButton } from '@clearkit/react';

import AudienceFormWarning from '../AudienceFormWarning';
import refreshFacebookAdAccount from './refreshFacebookAdAccount.graphql';

export default function FacebookTerms({
  isDisabled,
  facebookAdAccountId,
  termsUrl,
  onTermsAccepted,
}) {
  const [awaitingVerification, setAwaitingVerification] = useState(false);
  const [userAcceptedTerms, setUserAcceptedTerms] = useState(null);

  const [refreshTerms, { loading }] = useMutation(refreshFacebookAdAccount);

  const onClickAcceptTerms = () => {
    setAwaitingVerification(true);
  };

  const onClickVerifyTerms = async () => {
    const response = await refreshTerms({
      variables: {
        input: {
          facebookAdAccountId: facebookAdAccountId,
        },
      },
    });

    const termsAccepted = response.data.response.node.termsAccepted;

    if (termsAccepted) {
      onTermsAccepted();
    }

    setUserAcceptedTerms(termsAccepted);
    setAwaitingVerification(false);
  };

  return (
    <AudienceFormWarning
      message={
        !awaitingVerification && userAcceptedTerms === false ? (
          <span>
            Oops! It appears the Facebook Custom Audience Terms were not
            properly accepted. Please try again.
          </span>
        ) : (
          <span>
            Facebook requires that you accept the Custom Audience Terms of
            Service before creating your audience.
          </span>
        )
      }>
      <div className="flex">
        <div className="w-10"></div>
        <div className="flex-1">
          {awaitingVerification ? (
            <CKButton
              dataTestId="FacebookTerms__verify"
              variant={CKButton.Variant.bold}
              variantColor={CKButton.VariantColor.yellow}
              onClick={onClickVerifyTerms}
              isDisabled={isDisabled}
              isLoading={loading}>
              Verify Facebook Terms of Service
            </CKButton>
          ) : (
            <CKButton
              dataTestId="FacebookTerms__reviewAccept"
              variant={CKButton.Variant.bold}
              variantColor={CKButton.VariantColor.yellow}
              as="a"
              target="_blank"
              href={termsUrl}
              onClick={onClickAcceptTerms}
              isDisabled={isDisabled}
              isLoading={loading}
              rightIcon={<GoExternal />}>
              Review and accept terms
            </CKButton>
          )}
        </div>
      </div>
    </AudienceFormWarning>
  );
}
